import { GetProviderOrganizationAdministratorListRes, PageCount } from "./Model";
export const GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_LOADING =
  "GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_LOADING";
export const GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_SUCCESS =
  "GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_SUCCESS";
export const GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_FAIL =
  "GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_FAIL";
export const GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_DATA = "GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_DATA";
export const GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_API_MSG =
  "GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_API_MSG";
export const GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_API_RES =
  "GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_API_RES";

export interface GetProviderOrgAdministratorListState {
  getProviderOrgAdministratorRes: GetProviderOrganizationAdministratorListRes;
  loading: boolean;
  errorMsg: string;
  status: number;
}
export interface GetProviderOrgAdministratorListLoading {
  type: typeof GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_LOADING;
  loading: boolean;
}
export interface GetProviderOrgAdministratorListSuccess {
  type: typeof GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_SUCCESS;
  payload: GetProviderOrganizationAdministratorListRes;
}
export interface GetProviderOrgAdministratorListFail {
  type: typeof GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_FAIL;
  payload: GetProviderOrganizationAdministratorListRes;
  errorMsg: string;
  status: number;
}
export interface GetProviderOrgAdministratorListAPIMsg {
  type: typeof GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_API_MSG;
  payload: GetProviderOrganizationAdministratorListRes;
  errorMsg: string;
  status: number;
}
export interface GetProviderOrgAdministratorListAPIRes {
  type: typeof GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_API_RES;
  payload: GetProviderOrganizationAdministratorListRes;
  errorMsg: string;
  status: number;
}

interface GetProviderOrgAdministratorListDataAction {
  type: typeof GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_DATA;
  payload: GetProviderOrganizationAdministratorListRes;
  pageCount: PageCount;
}

export type GetProviderOriganizationListActionTypes =
  | GetProviderOrgAdministratorListLoading
  | GetProviderOrgAdministratorListSuccess
  | GetProviderOrgAdministratorListFail
  | GetProviderOrgAdministratorListAPIMsg
  | GetProviderOrgAdministratorListDataAction
  | GetProviderOrgAdministratorListAPIRes;
